const VALIDATION_PREFIX = 'Validation: ';

export const SAVE_ERROR_MESSAGE =
  'L’enregistrement a échoué. Vérifiez vos informations et réessayez.';

/**
 * Fields rejected by the API's StrictValidationPipe, whose 400 message reads
 * "Validation: email must be an email, phone must be …". Each class-validator
 * constraint message starts with the property name. Empty for any other error.
 *
 * The parsing below mirrors `StrictValidationPipe` in
 * `apps/api/src/core/validations/validationPipes.ts`: constraints joined with
 * ", ", field name first token. A constraint message containing ", " would
 * yield bogus field names here — callers then show the generic error.
 */
export const getRejectedFields = (error: unknown): string[] => {
  const message = (error as { response?: { data?: { message?: unknown } } })
    ?.response?.data?.message;
  if (typeof message !== 'string' || !message.startsWith(VALIDATION_PREFIX))
    return [];
  return message
    .slice(VALIDATION_PREFIX.length)
    .split(', ')
    .map((constraint) => constraint.split(' ')[0]);
};
